import React from 'react'
import { Link } from 'react-router-dom'
import './Abhi.css'

function Abhi() {
    return (
        <div className='abhi_prajapati'>
            <h1>Abhi Prajapati</h1>
            <Link>
            <p>Projects</p>
            </Link>
            <Link>
            <h2>Blogs</h2>
            </Link>
           
            <img src='images/My Photo.jpg'></img>
            <h3>Web Developer, Building <a href='https://dinebahar-mern.web.app/'>dine-bahar</a></h3>
            <p>Hello People, I'm a Web Developer.</p>
            <p>I'm an ICT engineering student at Pandit Deendayal Energy University(PDEU).</p>
            <p>I'm also an Sub-Committee member of SnT Web Development Committee.</p>
            <p>I have been working on latest Web Technologies 
                like React JS, Node JS, Express, Firebase, Stripe, etc.
            </p>
            <p>I'm also an Start-Up enthusiast.I like to read about Finance, Startups and Entreprenuership.</p>
            <p>Sometimes I also tweet about what I learn.</p> 
            <h3 className='social'>Social Links</h3>
            <a href="https://www.instagram.com/__mr._prajapati_/"><img className="ing" src="/images/ig.png"/></a>
            <a href="https://twitter.com/AbhiPareshkumar"><img className="twt" src="/images/twitter.png"/></a>
    
        </div>
    )
}

export default Abhi
